export class UpdateActionApprovalRuleResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "actionApprovalRule",
            "baseName": "actionApprovalRule",
            "type": "ActionApprovalRule",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateActionApprovalRuleResponse.attributeTypeMap;
    }
    constructor() {
    }
}
